import { render, staticRenderFns } from "./comunidad.vue?vue&type=template&id=43a4f514&"
import script from "./comunidad.vue?vue&type=script&lang=js&"
export * from "./comunidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports